import React from "react";
import { useNavigate } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
// import React, { useState } from "react";
// import Sample from "./Sample";

function Product() {
    let navigate = useNavigate();
    return (
        <>
        <Header></Header>
            <section className="img-main">
                <h1 className="img-info prdt">products</h1>

                <div className="img-imp">

                    <div className="img-imp-one">
                        <div className="container">
                            <img src="./sealimg/j1-type.png" className="j1-type" alt="img"></img>
                            <p className="img-first">j1 type</p>
                            <button className="img-btn" onClick={() => navigate('/new?pid=HEXA-J1-type')}> more detail</button>
                        </div>

                        <div className="container">
                            <img src="./sealimg/hexa-02.png" className="j1-type" alt="img"></img>
                            <p className="img-second">hexa-02</p>
                            <button className="img-btn" onClick={() => navigate('/new?pid=HEXA-02')}> more detail</button>
                        </div>
                    </div>

                    <div className="img-imp-two">
                        <div className="container">
                            <img src="./sealimg/hexa-301.png" className="j1-type" alt="img"></img>
                            <p className="img-third">hexa-301</p>
                            <button className="img-btn" onClick={() => navigate('/new?pid=HEXA-301')}> more detail</button>
                        </div>

                        <div className="container">
                            <img src="./sealimg/hexa-502.png" className="j1-type" alt="img"></img>
                            <p className="img-fourth">hexa-502</p>
                            <button className="img-btn" onClick={() => navigate('/new?pid=HEXA-502')}> more detail</button>
                        </div>
                    </div>

                </div>


                <div className="img-imp">

                    <div className="img-imp-one">
                        <div className="container">
                            <img src="./sealimg/hexa-560.png" className="j1-type" alt="img"></img>
                            <p className="img-first">hexa-560</p>
                            <button className="img-btn" onClick={() => navigate('/new?pid=HEXA-560')}> more detail</button>
                        </div>

                        <div className="container">
                            <img src="./sealimg/hexa-560d.png" className="j1-type" alt="img"></img>
                            <p className="img-second">hexa-560d</p>
                            <button className="img-btn" onClick={() => navigate('/new?pid=HEXA-560D')}> more detail</button>
                        </div>
                    </div>

                    <div className="img-imp-two">
                        <div className="container">
                            <img src="./sealimg/hexa-2100.png" className="j1-type" alt="img"></img>
                            <p className="img-third">hexa-2100</p>
                            <button className="img-btn" onClick={() => navigate('/new?pid=HEXA-2100')}> more detail</button>
                        </div>

                        <div className="container">
                            <img src="./sealimg/hexa-alfa.png" className="j1-type" alt="img"></img>
                            <p className="img-fourth">hexa-alfa</p>
                            <button className="img-btn" onClick={() => navigate('/new?pid=HEXA-alfa')}> more detail</button>
                        </div>
                    </div>

                </div>

                <div className="img-imp">

                    <div className="img-imp-one">
                        <div className="container">
                            <img src="./sealimg/hexa-g04.png" className="j1-type" alt="img"></img>
                            <p className="img-first">hexa-g04</p>
                            <button className="img-btn" onClick={() => navigate('/new?pid=HEXA-g04')}> more detail</button>
                        </div>

                        <div className="container">
                            <img src="./sealimg/hexa-g05.png" className="j1-type" alt="img"></img>
                            <p className="img-second">hexa-g05</p>
                            <button className="img-btn" onClick={() => navigate('/new?pid=HEXA-g05')}> more detail</button>
                        </div>
                    </div>

                    <div className="img-imp-two">
                        <div className="container">
                            <img src="./sealimg/hexa-g11-g12-g13.png" className="j1-type" alt="img"></img>
                            <p className="img-third hexa-g11">hexa-g11-g12-g13</p>
                            <button className="img-btn" onClick={() => navigate('/new?pid=HEXA-g11-g12-g13')}> more detail</button>
                        </div>

                        <div className="container">
                            <img src="./sealimg/hexa-glf.png" className="j1-type" alt="img"></img>
                            <p className="img-fourth">hexa-glf</p>
                            <button className="img-btn" onClick={() => navigate('/new?pid=HEXA-glf')}> more detail</button>
                        </div>
                    </div>


                </div>

                <div className="img-imp">

                    <div className="img-imp-one">
                        <div className="container">
                            <img src="./sealimg/hexa-h7n.png" className="j1-type" alt="img"></img>
                            <p className="img-first">hexa-h7n</p>
                            <button className="img-btn" onClick={() => navigate('/new?pid=HEXA-h7n')}> more detail</button>
                        </div>

                        <div className="container">
                            <img src="./sealimg/hexa-hj92.png" className="j1-type" alt="img"></img>
                            <p className="img-second">hexa-hJ92</p>
                            <button className="img-btn" onClick={() => navigate('/new?pid=HEXA-hj92')}> more detail</button>
                        </div>
                    </div>


                    <div className="img-imp-two">
                        <div className="container">
                            <img src="./sealimg/hexa-jc2.png" className="j1-type" alt="img"></img>
                            <p className="img-third">hexa-jC2</p>
                            <button className="img-btn" onClick={() => navigate('/new?pid=HEXA-jc2')}> more detail</button>
                        </div>

                        <div className="container">
                            <img src="./sealimg/hexa-m74d.png" className="j1-type" alt="img"></img>
                            <p className="img-fourth">hexa-m74D</p>
                            <button className="img-btn" onClick={() => navigate('/new?pid=HEXA-m74d')}> more detail</button>
                        </div>
                    </div>


                </div>

                <div className="img-imp">

                    <div className="img-imp-one">
                        <div className="container">
                            <img src="./sealimg/hexa-multi.png" className="j1-type" alt="img"></img>
                            <p className="img-first">hexa-multi</p>
                            <button className="img-btn" onClick={() => navigate('/new?pid=HEXA-multi')}> more detail</button>
                        </div>

                        <div className="container">
                            <img src="./sealimg/hexa-open.png" className="j1-type" alt="img"></img>
                            <p className="img-second">hexa-open</p>
                            <button className="img-btn" onClick={() => navigate('/new?pid=HEXA-open')}> more detail</button>
                        </div>
                    </div>


                    <div className="img-imp-two">
                        <div className="container">
                            <img src="./sealimg/hexa-single.png" className="j1-type" alt="img"></img>
                            <p className="img-third">hexa-single</p>
                            <button className="img-btn" onClick={() => navigate('/new?pid=HEXA-single')}> more detail</button>
                        </div>

                        <div className="container">
                            <img src="./sealimg/hexa-submersi.png" className="j1-type" alt="img"></img>
                            <p className="img-fourth hexa-submersi">hexa-submersi</p>
                            <button className="img-btn" onClick={() => navigate('/new?pid=HEXA-submersi')}> more detail</button>
                        </div>

                    </div>


                </div>

                <div className="img-imp">

                    <div className="img-imp-one">
                        <div className="container">
                            <img src="./sealimg/hexa-teflon-bellow.png" className="j1-type" alt="img"></img>
                            <p className="img-first hexa-teflon">hexa-teflon-bellow</p>
                            <button className="img-btn" onClick={() => navigate('/new?pid=HEXA-teflon')}> more detail</button>
                        </div>

                        <div className="container">
                            <img src="./sealimg/hexa-z1-conicle.png" className="j1-type" alt="img"></img>
                            <p className="img-second hexa-z1">hexa-z1-conicle</p>
                            <button className="img-btn" onClick={() => navigate('/new?pid=HEXA-z1-conicle')}> more detail</button>
                        </div>
                    </div>


                    <div className="img-imp-two">
                        <div className="container">
                            <img src="./sealimg/hexa-car-conicle.png" className="j1-type" alt="img"></img>
                            <p className="img-third">hexa-car-conicle</p>
                            <button className="img-btn" onClick={() => navigate('/new?pid=HEXA-car-conicle')}> more detail</button>
                        </div>

                        <div className="container">
                            <img src="./sealimg/hexa-ssic-car.png" className="j1-type" alt="img"></img>
                            <p className="img-fourth">hexa-m74D</p>
                            <button className="img-btn" onClick={() => navigate('/new?pid=HEXA-')}> more detail</button>
                        </div>
                    </div>
                </div>

                <div className="mb-imp"></div>

                {/* <button>gdjs</button> */}
            </section>

            <Footer></Footer>
        </>
    );
};

export default Product